import { FC, memo } from 'react';
import { useAppDispatch } from 'app/hooks';
import { detectStore, useMobileAppLink } from '../../utils';
import { setMobileAppModalOpen } from '../../request-single-page-slice';
import { useResponsive } from '../../../../hooks/use-responsive';
import { MobileWrapper, LogoBox, Icon, TextBox } from './mobile-app.styled';
import { Button, Text } from '../../components-v4';

export const MobileApp: FC = memo(() => {
  const { viewport } = useResponsive();
  const dispatch = useAppDispatch();
  const store = detectStore();
  const link = useMobileAppLink(store);

  const handleDownload = () => {
    if (!viewport.desktop) {
      window.open(link, '_blank', 'noopener noreferrer');
      return;
    }

    dispatch(setMobileAppModalOpen(true));
  };

  if (viewport.desktop) {
    return (
      <Button size="s" mode="accent" variant="ghost" onClick={handleDownload}>
        Скачать мобильное приложение
      </Button>
    );
  }

  return (
    <MobileWrapper isTablet={viewport.tablet}>
      <LogoBox>
        <Icon isTablet={viewport.tablet} />
        <TextBox>
          <Text
            variant={viewport.mobile ? 'heading-4' : 'heading-3'}
            color="gray.800"
          >
            Кабинет-жителя.рф
          </Text>
          <Text
            variant={viewport.mobile ? 'body-14' : 'body-16'}
            color="gray.500"
          >
            Открыть в приложении
          </Text>
        </TextBox>
      </LogoBox>
      <Button
        mode="accent"
        variant="main"
        size={viewport.mobile ? 's' : 'm'}
        onClick={handleDownload}
      >
        Скачать
      </Button>
    </MobileWrapper>
  );
});
